import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import CKEditorComman from '../componets/CkEditor'
import Header from '../componets/Layout/Header'
import Sidebar from '../componets/Layout/Sidebar'
import { editTermsCondition, getTermCondition } from '../controller'
import { requestHandler } from '../helper'

function TermsAndConditions() {
    const [is_Editing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        content: ''
    });



    const getTermsData = async () => {
        await requestHandler(
            async () => await getTermCondition(true),
            null,
            (res) => {
                setFormData(res.data);
            },
            () => { }
        );
    };

    useEffect(() => {
        getTermsData();
    }, []); //


    const handleContentChange = (content) => {
        setFormData({ ...formData, content });
    };

    const handleEditButtonClick = async () => {
        if (is_Editing) {
            await requestHandler(
                async () => await editTermsCondition(formData.content, formData._id),
                null,
                (res) => {
                    toast.success(res.message);
                    getTermsData();
                    setIsEditing(false);
                },
                () => { }
            );
        } else {
            setIsEditing(!is_Editing);
        }
    }
    return (
        <>
            <div>
                <div className='layouy-main'>
                    <div className='sidebar-hide-show'>
                        <Sidebar />
                    </div>
                    <div className='w-100'>
                        <Header />
                        <div className="tebs-title">
                            <p className='active'>Terms and Conditions</p>
                        </div>
                        <section>
                            <div className="card main-card">
                                <div className="card-body px-0 pt-0">
                                    <div className="table-main">
                                        <div className="card">
                                            <div className="card-body h-100">
                                                <div className='tables-container'>
                                                    <div className="d-sm-block d-md-flex d-lg-flex justify-content-between align-items-center mb-1">
                                                        <div className="mb-3 mb-md-0 mt-3 mt-md-0 col-xl-4 col-lg-6 col-md-7">
                                                        </div>
                                                        <div>
                                                            <button className='add-btn border-0 rounded-3' onClick={handleEditButtonClick}>
                                                                <p className='m-0'>{is_Editing ? 'Save' : 'Update'}</p>
                                                            </button>

                                                        </div>
                                                    </div>
                                                    <div className='row policy-ckeditor'>
                                                        <div className="col-lg-12">
                                                            {!is_Editing ? (
                                                                <div dangerouslySetInnerHTML={{ __html: formData.content }} />
                                                            ) : (

                                                                <CKEditorComman onContentChange={handleContentChange} content={formData.content} />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </>

    )

}

export default TermsAndConditions